import React from "react"

const Facebook = ({ color = "default" }) => {
  const strokeColor = color === "dark" ? "#ffffff" : "#121212"
  const iconColor = color === "dark" ? "#ffffff" : "#121212"

  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
      onMouseEnter={e => {
        const rect = e.currentTarget.querySelector("rect")
        const paths = e.currentTarget.querySelectorAll("path")
        if (rect) {
          rect.setAttribute("fill", strokeColor)
        }
        paths.forEach(path => {
          if (path.getAttribute("fill") !== "white") {
            path.setAttribute("fill", color === "dark" ? "#121212" : "#ffffff")
          }
        })
      }}
      onMouseLeave={e => {
        const rect = e.currentTarget.querySelector("rect")
        const paths = e.currentTarget.querySelectorAll("path")
        if (rect) {
          rect.setAttribute("fill", "none")
        }
        paths.forEach(path => {
          if (path.getAttribute("fill") !== "white") {
            path.setAttribute("fill", iconColor)
          }
        })
      }}
    >
      <rect
        x="1.53027"
        y="1"
        width="57.9698"
        height="58"
        rx="28.9849"
        stroke={strokeColor}
        strokeWidth="2"
        fill="none"
      />
      <mask
        id="mask0_1260_2240"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="24"
        y="18"
        width="14"
        height="25"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.5183 18H37.4956V43H24.5183V18Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1260_2240)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.354 43V31.5971H24.5183V27.1506H28.354V23.872C28.354 20.0724 30.6758 18 34.0689 18C35.6944 18 37.0868 18.1217 37.4956 18.1769V22.1463L35.1413 22.152C33.2963 22.152 32.9424 23.0255 32.9424 24.315V27.1506H37.3414L36.767 31.5914H32.9424V43"
          fill={iconColor}
        />
      </g>
    </svg>
  )
}

export default Facebook
